import HttpService from '@/common/services/HttpService'
import { type InstanceParameterDTOV1 } from '@/common/types/instanceParameter'

const API_PARAMETERS = '/api/v1/parameters'
/**
 * Get instance parameter by code
 * @param code parameter code
 * @returns InstanceParameterDTOV1
 */
export const getParameterByCode = async (code: string): Promise<InstanceParameterDTOV1> => {
  return HttpService.getData<InstanceParameterDTOV1>(API_PARAMETERS + '/' + code)
}

export const getParameterList = () => {
  return HttpService.getData<InstanceParameterDTOV1[]>(API_PARAMETERS)
}

export const updateParameterValue = (paramCode: string, paramValue: string): Promise<InstanceParameterDTOV1> => {
  return HttpService.putData<InstanceParameterDTOV1>(API_PARAMETERS + '/' + paramCode, paramValue, { headers: { 'Content-Type': 'text/plain' } })
}
